"use client"

import Container from "./Home.style"
import EscolhaProduto from "../../assets/escolha-o-produto.svg"
import SoBuscar from "../../assets/so-ir-buscar.svg"
import ReserveProduto from "../../assets/reserve.svg"
import AddToHomeStep1 from "../../assets/add-to-home-step-1.png"
import AddToHomeStep2 from "../../assets/add-to-home-step-2.png"
import AddToHomeStep3 from "../../assets/add-to-home-step-3.png"
import HeroWoman from "../../assets/women-homepage.png"
import IconLeaf from "../../assets/leaf.svg"
import OfertouLogo from "../../assets/logo-homepage.svg"
import Footer from "../../components/Footer" 

export interface City {
  id: number
  nome: string
}

const Home = () => {
  return (
    <Container>
    <main className="min-h-screen overflow-hidden">
      {/* Header */}
      <header className="bg-[#e9e2db] py-5 px-4 sm:px-6 md:px-12 lg:px-24 w-full sticky top-0 z-50">
        <div className="flex items-center justify-between max-w-[1400px] mx-auto">
          <a href="/" className="mr-8">
            <img src={OfertouLogo} alt="Ofertou Logo" width={130} height={45} className="h-10 w-auto" />
          </a>
          <nav className="hidden md:flex space-x-12">
            <a href="/app" className="text-[#212121] hover:text-[#eb6813] font-medium text-base lg:text-lg transition-colors">
              Ofertas
            </a>
            <a
              href="#como-funciona"
              className="text-[#212121] hover:text-[#eb6813] font-medium text-base lg:text-lg transition-colors"
            >
              Como Funciona
            </a>
            <a href="https://espera.ofertou.app" className="text-[#212121] hover:text-[#eb6813] font-medium text-base lg:text-lg transition-colors">
              Divulgar produtos
            </a>
          </nav>
          <div className="md:hidden flex items-center">
            <button className="p-2 text-[#212121]">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
              </svg>
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="bg-[#e9e2db] pt-8 sm:pt-12 md:pt-16 md:pb-16 px-4 sm:px-6 md:px-12 lg:px-24 relative overflow-hidden">
        <div className="flex flex-col md:flex-row items-center justify-between max-w-6xl mx-auto gap-6 md:gap-8">
          <div className="w-full md:w-1/2 lg:w-5/12 z-10 md:pt-8 text-center md:text-left">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#212121] mb-6 sm:mb-8 max-w-md mx-auto md:mx-0 leading-tight">
              Economize em produtos próximos ao vencimento!
            </h1>
            <div className="flex flex-col items-center md:items-start gap-4 mb-4">
              <a
                href="/app"
                className="inline-block bg-[#eb6813] text-white font-medium py-3 px-8 rounded-md hover:bg-[#d55f11] transition-all hover:shadow-lg text-center min-w-[160px]"
              >
                VER OFERTAS
              </a>
              <p className="text-sm text-[#212121] mt-2">
                Você é lojista?
                <a href="https://espera.ofertou.app" className="underline ml-1 text-[#eb6813] font-medium">
                  Clique aqui!
                </a>
              </p>
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:w-7/12 flex justify-center md:justify-end relative z-20 mt-6 md:mt-0">
            <div className="relative">
              <img
                src={HeroWoman}
                alt="Pessoa mostrando o aplicativo Ofertou"
                width={600}
                height={700}
                className="w-auto h-auto max-h-[450px] sm:max-h-[550px] md:max-h-[650px] object-contain"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section with curved top */}
      <section className="bg-[#eb6813] text-white py-24 sm:py-32 md:py-40 lg:py-48 px-4 sm:px-6 md:px-12 lg:px-24 relative mt-8 md:mt-0">
        <div className="absolute top-0 left-0 right-0 h-20 bg-[#e9e2db] rounded-b-[100%_50%] z-10"></div>
        <div className="text-center max-w-xs sm:max-w-md md:max-w-2xl mx-auto mt-12 sm:mt-16 md:mt-20 relative z-20">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-8 sm:mb-10 leading-tight">
            Você economiza, evita desperdícios e ajuda o comércio local
          </h2>
          <p className="text-base sm:text-lg md:text-xl mb-10 sm:mb-12 max-w-2xl mx-auto leading-relaxed">
            Encontre produtos de qualidade com descontos incríveis e contribua para um mundo mais sustentável, reduzindo
            o desperdício de alimentos.
          </p>
          <div className="flex justify-center mt-8 sm:mt-10">
            <img src={IconLeaf} className="w-12 h-12 sm:w-16 sm:h-16" alt="Leaf Icon" />
          </div>
        </div>
      </section>

      {/* How it Works Section */}
      <section
        id="como-funciona"
        className="bg-white py-16 sm:py-20 md:py-24 px-4 sm:px-6 md:px-12 lg:px-24 relative -mt-12 sm:-mt-16 md:-mt-20"
      >
        <div className="bg-white rounded-3xl shadow-2xl p-8 sm:p-10 md:p-12 max-w-5xl mx-auto">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-10 sm:mb-14 text-[#212121]">Como Funciona</h2>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-10 sm:gap-12">
            {/* Step 1 */}
            <div className="flex flex-col items-center text-center h-full bg-white rounded-xl p-6 hover:shadow-md transition-shadow group">
              <div className="w-10 h-10 bg-[#eb6813] text-white rounded-full flex items-center justify-center text-xl font-bold mb-6 group-hover:scale-110 transition-transform">
                1
              </div>
              <div className="mb-6 flex items-center justify-center h-[120px]">
                <img 
                  src={EscolhaProduto} 
                  alt="Selecione sua cidade" 
                  width={120} 
                  height={120} 
                  className="group-hover:-translate-y-1 transition-transform"
                />
              </div>
              <p className="text-sm sm:text-base text-[#333] leading-relaxed">
                Clique aqui, selecione sua cidade e escolha o produto com desconto incrível
              </p>
            </div>

            {/* Step 2 */}
            <div className="flex flex-col items-center text-center h-full bg-white rounded-xl p-6 hover:shadow-md transition-shadow group">
              <div className="w-10 h-10 bg-[#eb6813] text-white rounded-full flex items-center justify-center text-xl font-bold mb-6 group-hover:scale-110 transition-transform">
                2
              </div>
              <div className="mb-6 flex items-center justify-center h-[120px]">
                <img 
                  src={ReserveProduto} 
                  alt="Reserve mandando uma mensagem" 
                  width={120} 
                  height={120}
                  className="group-hover:-translate-y-1 transition-transform"
                />
              </div>
              <p className="text-sm sm:text-base text-[#333] leading-relaxed">
                Reserve mandando uma mensagem para a loja
              </p>
            </div>

            {/* Step 3 */}
            <div className="flex flex-col items-center text-center h-full bg-white rounded-xl p-6 hover:shadow-md transition-shadow group">
              <div className="w-10 h-10 bg-[#eb6813] text-white rounded-full flex items-center justify-center text-xl font-bold mb-6 group-hover:scale-110 transition-transform">
                3
              </div>
              <div className="mb-6 flex items-center justify-center h-[120px]">
                <img 
                  src={SoBuscar} 
                  alt="Pronto, agora é só ir buscar" 
                  width={120} 
                  height={120}
                  className="group-hover:-translate-y-1 transition-transform"
                />
              </div>
              <p className="text-sm sm:text-base text-[#333] leading-relaxed">
                Pronto, agora é só ir buscar!
              </p>
            </div>
          </div>

          <div className="flex justify-center mt-12">
            <a
              href="https://wa.me/12991895138"
              target="_blank"
              className="flex items-center gap-2 bg-[#469b54] text-white font-medium py-3 px-8 rounded-md hover:bg-[#3a8a46] transition-colors shadow-md hover:shadow-lg"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.297-.497.1-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"
                  fill="#fff"
                />
              </svg>
              Tire dúvidas
            </a>
          </div>
        </div>
      </section>

      {/* Add to Home Screen Section */}
      <section className="py-16 sm:py-20 px-4 sm:px-6 md:px-12 lg:px-24 bg-[#f9f5f1]">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-10 sm:mb-14 text-[#212121]">
          Adicione o Ofertou à tela inicial do seu celular
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 max-w-5xl mx-auto">
          {/* Step 1 */}
          <div className="flex flex-col items-center text-center bg-white p-6 rounded-2xl shadow-md hover:shadow-lg transition-shadow">
            <div className="w-10 h-10 bg-[#eb6813] text-white rounded-full flex items-center justify-center text-xl font-bold mb-4">1</div>
            <p className="text-sm sm:text-base mb-6 text-[#333] font-medium">Toque no ícone de compartilhar do navegador do seu celular</p>
            <div className="mt-auto">
                <img src={AddToHomeStep1} className="max-w-full h-auto rounded-lg shadow-sm" alt="Step 1 screenshot"/>
            </div>
          </div>

          {/* Step 2 */}
          <div className="flex flex-col items-center text-center bg-white p-6 rounded-2xl shadow-md hover:shadow-lg transition-shadow">
            <div className="w-10 h-10 bg-[#eb6813] text-white rounded-full flex items-center justify-center text-xl font-bold mb-4">2</div>
            <p className="text-sm sm:text-base mb-6 text-[#333] font-medium">Procure e toque na opção "Adicionar à tela de início"</p>
            <div className="mt-auto">
                <img src={AddToHomeStep2} className="max-w-full h-auto rounded-lg shadow-sm" alt="Step 2 screenshot"/>
            </div>
          </div>

          {/* Step 3 */}
          <div className="flex flex-col items-center text-center bg-white p-6 rounded-2xl shadow-md hover:shadow-lg transition-shadow sm:col-span-2 md:col-span-1 sm:max-w-xs sm:mx-auto md:max-w-none">
            <div className="w-10 h-10 bg-[#eb6813] text-white rounded-full flex items-center justify-center text-xl font-bold mb-4">3</div>
            <p className="text-sm sm:text-base mb-6 text-[#333] font-medium">Agora é só tocar na opção "Add", "Adicionar" ou semelhante</p>
            <div className="mt-auto">
                <img src={AddToHomeStep3} className="max-w-full h-auto rounded-lg shadow-sm" alt="Step 3 screenshot"/>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
    </Container>
  )
}

export default Home
